import * as THREE from 'three';

export class FloatingData {
    public mesh: THREE.InstancedMesh;
    private count: number;
    private dummy: THREE.Object3D;
    private particles: {
        position: THREE.Vector3;
        speed: number;
        offset: number;
    }[];

    constructor(count: number = 200) {
        this.count = count;
        this.dummy = new THREE.Object3D();
        this.particles = [];

        // Geometry: simple small plane or box
        const geometry = new THREE.BoxGeometry(0.02, 0.05, 0.02);

        // Material: glowing blue/cyan
        const material = new THREE.MeshBasicMaterial({
            color: 0x00d4ff,
            transparent: true,
            opacity: 0.6
        });

        this.mesh = new THREE.InstancedMesh(geometry, material, count);
        this.mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
        this.mesh.name = 'floating_data_particles';

        this.initParticles();
    }

    private initParticles(): void {
        for (let i = 0; i < this.count; i++) {
            const x = (Math.random() - 0.5) * 10;
            const y = Math.random() * 5;
            const z = (Math.random() - 0.5) * 10;

            this.particles.push({
                position: new THREE.Vector3(x, y, z),
                speed: 0.2 + Math.random() * 0.5,
                offset: Math.random() * 100
            });

            this.dummy.position.set(x, y, z);
            this.dummy.updateMatrix();
            this.mesh.setMatrixAt(i, this.dummy.matrix);
        }
        this.mesh.instanceMatrix.needsUpdate = true;
    }

    public update(deltaTime: number): void {
        const time = Date.now() * 0.001;

        for (let i = 0; i < this.count; i++) {
            const particle = this.particles[i];

            // Move up
            particle.position.y += particle.speed * deltaTime;

            // Reset if too high
            if (particle.position.y > 4) {
                particle.position.y = 0;
                particle.position.x = (Math.random() - 0.5) * 8; // Respawn randomly
                particle.position.z = (Math.random() - 0.5) * 8;
            }

            this.dummy.position.copy(particle.position);

            // Bobbing/Floating motion
            this.dummy.position.x += Math.sin(time + particle.offset) * 0.002;
            this.dummy.position.z += Math.cos(time + particle.offset) * 0.002;

            // Rotate randomly
            this.dummy.rotation.x = time + particle.offset;
            this.dummy.rotation.y = time * 0.5;

            this.dummy.updateMatrix();
            this.mesh.setMatrixAt(i, this.dummy.matrix);
        }

        this.mesh.instanceMatrix.needsUpdate = true;
    }
}
